module.exports = __webpack_public_path__ + "static/wix_monei-be0cf8b232785c3d6d9dabdbc7536ba2.svg";